const translations = {
    de: {
        externalContent: 'Externer Inhalt',
        bodyPreLink: 'Dieser Inhalt kann nur angezeigt werden wenn du unsere ',
        bodyPostLink: ' akzeptierst.',
        cookies: 'Cookie-Richtlinien',
        accept: 'Cookies erlauben',
    },
    en: {
        externalContent: 'External content',
        bodyPreLink: 'This content can only be displayed, after you agreed to our ',
        bodyPostLink: '.',
        cookies: 'cookie policies',
        accept: 'Allow cookies',
    },
};

export default translations;
